import React from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils';

interface EmptyResultProps {
  title?: string;
  description?: string;
  buttonText?: string;
  buttonOnClick?: () => void;
  className?: string;
}

const EmptyResult = ({ 
  title = "We couldn’t find anything for your search", 
  description = "Try adjusting your filters or searching something else.", 
  buttonText = "Clear filter", 
  buttonOnClick = () => {},
  className = "",
}: EmptyResultProps) => {
  return (
    <div className={cn("text-center", className)}>
      
      <h3>{title}</h3>
      <p className="paragraph-lg text-muted-foreground mt-4">{description}</p>
      <Button
        size="lg"
        variant="outline"
        onClick={buttonOnClick}
        className="mt-8"
      >
        {buttonText}
      </Button>
    </div>
  )
}

export { EmptyResult }